import React, { PropTypes } from 'react'

import './RescheduleAliadaProfile.scss'
import Avatar from 'components/Avatar'
import AliadaBasicInfo from 'components/AliadaBasicInfo'
import ServicePrice from 'components/ServicePrice'

const RescheduleAliadaProfile = ({aliada, serviceDuration}) => {
  const profilePicture = aliada.profilePicture.original

  return (
    <div className='RescheduleAliadaProfile'>
      <Avatar
        image={profilePicture}
        superaliada={aliada.superaliada}
        size={112}
        />

      <div className='RescheduleAliadaProfile-basicInfo'>
        <AliadaBasicInfo
          firstName={aliada.firstName}
          lastName={aliada.lastName}
          rating={aliada.averageRating}
          />

        <ServicePrice
          aliada={aliada}
          estimatedServiceHours={serviceDuration}
          />
      </div>
    </div>
  )
}

RescheduleAliadaProfile.displayName = 'RescheduleAliadaProfile'
RescheduleAliadaProfile.propTypes = {
  aliada: PropTypes.object.isRequired,
  serviceDuration: PropTypes.number.isRequired
}
RescheduleAliadaProfile.defaultProps = {}

export default RescheduleAliadaProfile



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/RescheduleAliadaProfile/RescheduleAliadaProfile.js